<app-spremiste-zaglavlje
  [parentArchiveName]="parentArchiveName"
  [parentObjectName]="arhiv"
/>
<ntap-prime-common-itemview #itemView></ntap-prime-common-itemview>
